import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, SubmissionError } from 'redux-form'
import { Button, Breadcrumb, Icon, Confirm } from 'semantic-ui-react'
import { lower } from 'change-case'

import PlaceholderView from '../Shareds/Placeholder'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import { validation, validateCase as vCase } from 'core/validate'
import CommentHistory from '../Detail/CommentHistory'
import Approvers from 'routes/ProcurementSystem/Shared/DocumentStep/Approvers'
import Information from '../Shareds/Information'
import ActionCommentModal from '../Shareds/ActionCommentModal'
import Attachment from '../Shareds/Attachment'
import { goodsServiceReceiptPath } from 'routes'
import { grStatus } from '../AttributeData'
import {
  validateField,
  validateAttachments,
  setUpGRPOs,
  setUpGRPOItems,
  checkAlertContract
} from '../helper'
import { 
  MainBodyContent, 
  K2ErrorModal, 
  StatusTag 
} from 'components'
import { 
  getGRDetailEdit,
  clearGRDetail,
  initializeGR,
  fetchPORelease,
  updateGR,
  deleteGR,
  getGRGOAWorkFlowEditMode,
  getGRErrorWorkFlow,
  callGRAction,
  getSpecialApprovalInfo
} from 'ducks/goodsServiceReceipt'
import { 
  showModal,
} from 'ducks/app'
import r from 'reactotron-react-js'

import { BottomActionsContainer } from './styled'

const EditGoodsServiceReceipt = props => {

  const { 
    history,
    change,
    goaWorkFlow,
    valueForm,
    k2workFlowError,
    grDetail,
    isDetail = false,
  } = props

  const [actionName, setActionName] = React.useState('')
  const [showDialogComment,setShowDialogComment] = React.useState(false)
  const [showConfirmAlertContract, setShowConfirmAlertContract] = React.useState(false)
  const [messageAlertContract, setMessageAlertContract] = React.useState([])
  const [requireMemo, setRequireMemo] = React.useState(false)

  React.useEffect(() => {
    const { match } = props
    window.scrollTo(0,0)
    if (match && match.params && match.params.grId) {
      props.initializeGR(isDetail)
      props.getGRDetailEdit(match.params.grId, history)
    }
    return (() => {
      props.clearGRDetail()
    })
  },[])

  React.useEffect(() => {
    if (valueForm&&valueForm.status&&valueForm.status!==0) {
      props.getGRErrorWorkFlow(valueForm.procInstId, valueForm.subProcInstId)
    }
  },[valueForm&&valueForm.status])

  React.useEffect(() => {
    if (valueForm&&valueForm.specialApprovalId) {
      props.getSpecialApprovalInfo(valueForm.specialApprovalId)
    }
  },[valueForm&&valueForm.specialApprovalId])

  React.useEffect(() => {
    if (Object.keys(grDetail).length) {
      let poNum = ''
      grDetail.goodsServiceReceiptPOs.forEach((x,i)=>{
        if(i==0){
          poNum += `'${x.purchaseOrderSapNumber}'`
        }else{
          poNum += `,'${x.purchaseOrderSapNumber}'`
        }
      })
      props.fetchPORelease({poSapNum:poNum})
    }
  },[grDetail])

  React.useEffect(() => {
    if(valueForm&&valueForm.id){
      props.getGRGOAWorkFlowEditMode({
        creater:valueForm?lower(valueForm.createdByUser):'',
        requester:valueForm?valueForm.requesterUser:'',
        companyCode:valueForm?valueForm.companyCode:'',
        poSapNumber:valueForm?(valueForm.goodsServiceReceiptPOs&&valueForm.goodsServiceReceiptPOs.length)?valueForm.goodsServiceReceiptPOs[0].purchaseOrderSapNumber:'':'',
        amount:valueForm?valueForm.billingAmount:'',
        currency:valueForm?valueForm.currencyCode:'',
        vendorCode:valueForm?valueForm.vendorCode:'',
        goaId:valueForm?valueForm.goaId:'',
        specialApprovalId:valueForm?valueForm.specialApprovalId:'',
        porjectManagerUsername:valueForm?valueForm.projectManagerUser:'',
        isFromVendor:valueForm?valueForm.isFromVendor:'',
      })
    }
  },[(valueForm&&valueForm.createdByUser),(valueForm&&valueForm.requesterUser),(valueForm&&valueForm.projectManagerUser),
    (valueForm&&valueForm.goodsServiceReceiptPOs),(valueForm&&valueForm.billingAmount),(valueForm&&valueForm.specialApprovalId)])

  React.useEffect(()=>{
    if(valueForm&&valueForm.goodsServiceReceiptPOs&&valueForm.goodsServiceReceiptPOs.length>0){
      setRequireMemo(false)
    }
  },[valueForm&&valueForm.goodsServiceReceiptPOs])

  const onSubmitForm = () => {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
    return sleep(100)
    .then(() => {
      if(actionName === 'Delete'){
        setShowDialogComment(false)
        props.deleteGR({
          docId:valueForm.id,
        }, history)
      }else{
        let errors = validateField(valueForm, actionName)
        setShowDialogComment(false)
        if(Object.keys(errors).length){
          scrollToFirstValidateFailElement(errors)
          throw new SubmissionError(errors)
        }else{
          if(actionName === 'Cancel'){
            props.callGRAction({
              docId:valueForm.id,
              sn:valueForm.sn,
              action:'Cancel',
              comment:valueForm.actionComment
            }, history)
          }else if(actionName === 'Revise'){
            props.callGRAction({
              docId:valueForm.id,
              sn:valueForm.sn,
              action:'Revise',
              comment:valueForm.actionComment
            }, history)
          }else {
            let missingAttachments = validateAttachments(valueForm, props.grType.data)
            if(missingAttachments.length){
              props.showModal(
                true, 
                'Please attach document!',
                <React.Fragment><ul>{missingAttachments.map(v => <li>{v.fieldName}</li>)}</ul></React.Fragment>
              )
            }else{
              let data = {...valueForm,goodsServiceReceiptPoItems:setUpGRPOItems(valueForm),goodsServiceReceiptPOs:setUpGRPOs(valueForm)}
              if(!data.isFinal){
                data.mainContractTotalValue = null
                data.contractNo = null
              }
              if(!data.advancePayment){
                data.advancePaymentNo = null
              }
              if(actionName==='save'){
                props.updateGR(data, history, false)
              }else{
                let check = checkAlertContract(valueForm, props.poReleaseDetail)
                if(check.alert){
                  setRequireMemo(true)
                  setMessageAlertContract(check.msgAlert)
                  setShowConfirmAlertContract(true)
                }else{
                  setRequireMemo(false)
                  if(actionName === 'submit'){
                    props.updateGR(data, history, true)
                  }else if(actionName === 'resubmit'){
                    props.updateGR(data, history, true)
                  }
                }
              }
            }
          }
        }
      }
    })
  } 

  const confirmAlertContractSubmit = () =>{
    setShowConfirmAlertContract(false)
    let missingAttachments = validateAttachments(valueForm, props.grType.data, requireMemo)
    if(missingAttachments.length){
      props.showModal(
        true, 
        'Please attach document!',
        <React.Fragment><ul>{missingAttachments.map(v => <li>{v.fieldName}</li>)}</ul></React.Fragment>
      )
    }else{
      let data = {...valueForm,goodsServiceReceiptPoItems:setUpGRPOItems(valueForm),goodsServiceReceiptPOs:setUpGRPOs(valueForm)}
      if(!data.isFinal){
        data.mainContractTotalValue = null
        data.contractNo = null
      }
      if(!data.advancePayment){
        data.advancePaymentNo = null
      }
      if(actionName === 'submit'){
        props.updateGR(data, history, true)
      }else if(actionName === 'resubmit'){
        props.updateGR(data, history, true)
      }
    }
  }

  return (
    <MainBodyContent
      headerTitle={<React.Fragment>{valueForm&&valueForm.isSpecialCreditTerm&&<Icon size='tiny' name='star' color='yellow'/>}{`Goods Service Receipt - Edit ${grDetail?grDetail.documentNumber?`#${grDetail.documentNumber}`:'':''}`}<span style={{width:'1rem'}}/>{grDetail&&<StatusTag status={grDetail&&grDetail.status} statusName={grStatus[grDetail?grDetail.status:0]}/>}</React.Fragment>}
      accessoriesHeader={
        <React.Fragment>
          <Approvers 
            approvers={goaWorkFlow.data} 
            status={valueForm&&valueForm.status}
            trigger={
              <Button 
                basic  
                circular 
                type='button' 
                loading={goaWorkFlow.loading} 
                content='View Approver' 
                labelPosition='right'
                icon='sort numeric down' />
            }
          />
        </React.Fragment>
      }
      breadcrumbs={
        <Breadcrumb
          icon="right angle"
          sections={[
            {
              key: 'GR',
              content: 'Goods Service Receipt',
              link: true,
              onClick: () => history.push(goodsServiceReceiptPath),
            },
            { key: 'GREdit', content: 'Edit', active: true },
          ]}
        />
      }
      accessoriesHeaderLeft={
        k2workFlowError.isError&&
          <K2ErrorModal checkK2Error={k2workFlowError}/>  
      }
    >
      {valueForm&&valueForm.id?<Information isCreate={false} isEdit={true} change={change}/>:<PlaceholderView/>}

      {valueForm&&valueForm.subDeliveryType&&
      <Attachment isCreate={false} isEdit={true} change={change} requireMemo={requireMemo}/>}
      <div style={{marginTop:'1rem'}}/>
      {valueForm&&(valueForm.status==5||valueForm.status==1)?
        <React.Fragment>
          <CommentHistory/>
        </React.Fragment>
        :null
      }
      {/* Confirm alert contract */}
      <Confirm
        open={showConfirmAlertContract}
        content={<div className='content' style={{whiteSpace:'pre-line'}}>{messageAlertContract.map(x=>x)}</div>}
        onCancel={()=>setShowConfirmAlertContract(false)}
        onConfirm={()=>confirmAlertContractSubmit()}
      />
      {valueForm&&<form onSubmit={props.handleSubmit(()=>onSubmitForm())}>
        <BottomActionsContainer>
          <Button 
            type='submit'
            content='Save' 
            icon='save' 
            labelPosition='right'
            style={{ marginRight: '0.3125rem' }}
            onClick={()=>setActionName('save')}
          />
          {valueForm&&valueForm.status==5?
          <Button 
            type='button'
            content='Save & Re-Submit'
            color='blue' 
            icon='save' 
            labelPosition='right'
            style={{ marginRight: '0.3125rem' }}
            onClick={()=>{
              setShowDialogComment(true)
              setActionName('resubmit')
            }}
          />
          :
          <Button 
            type='button'
            content='Save & Submit' 
            color='blue' 
            icon='save' 
            labelPosition='right'
            style={{ marginRight: '0.3125rem' }}
            onClick={()=>{
              setShowDialogComment(true)
              setActionName('submit')
            }}
          />
          }
          {valueForm&&valueForm.status==0?
          <Button 
            type='button'
            content='Delete' 
            color='red' 
            style={{ marginRight: '0.3125rem' }}
            onClick={()=>{
              setShowDialogComment(true)
              setActionName('Delete')
            }}
          />
          :
          valueForm&&valueForm.isFromVendor?
          <Button 
            type='button'
            content='Revise to Vendor'
            color='orange' 
            style={{ marginRight: '0.3125rem' }}
            onClick={()=>{
              setShowDialogComment(true)
              setActionName('Revise')
            }}
          />
          :
          <Button 
            type='button'
            content='Cancel' 
            color='orange' 
            style={{ marginRight: '0.3125rem' }}
            onClick={()=>{
              setShowDialogComment(true)
              setActionName('Cancel')
            }}
          />
          }
        </BottomActionsContainer>
      </form>}
      {showDialogComment&&<ActionCommentModal submit={props.handleSubmit(()=>onSubmitForm())} setShowDialogComment={setShowDialogComment} actionName={actionName}/>}
    </MainBodyContent>
  )

}

const validate = values => {
  let errors = {}  
  errors = validation(values, 'invoiceNumber', [vCase.maxLength20], errors)

  return errors
}

const mapStateToProps = (state, props) => {
  let grDetail = state.gr.grDetail
  let data = {...grDetail.data,
    grPos:grDetail.data.goodsServiceReceiptPOs,
    grPoItems:grDetail.data.goodsServiceReceiptPoItems,
    goodsServiceReceiptPOs:[],
    goodsServiceReceiptPoItems:[]
  }
  return ({
    initialValues: {
      ...data,
      deductRetentionRate:data.deductRetentionRate||null
    },
    grDetail:grDetail.data,
    goaWorkFlow: state.gr.goaWorkFlow,
    grType: state.gr.grType,
    k2workFlowError: state.gr.k2workFlowError,
    valueForm: getFormValues('formGR')(state),
    poReleaseDetail:state.gr.poReleaseDetail,
  })
}
const mapDispatchToProps = {
  getGRGOAWorkFlowEditMode,
  getGRErrorWorkFlow,
  getGRDetailEdit,
  clearGRDetail,
  initializeGR,
  fetchPORelease,
  updateGR,
  deleteGR,
  callGRAction,
  showModal,
  getSpecialApprovalInfo
}

const contForm = reduxForm({
  form: 'formGR',
  enableReinitialize: true,
  validate
})(EditGoodsServiceReceipt)

export default connect(mapStateToProps, mapDispatchToProps)(contForm)
